const getFullInfo = (state) => ({
  ...state.customer.accountInfo,
});

const getVehicles = (state) => state.customer.accountInfo.vehicles;

const getReviews = (state) => {
  const { asOwner, asRenter } = state.customer.accountInfo.reviews;
  return {
    asOwner: asOwner.map((e) => ({ ...e, text: e.review })),
    asRenter: asRenter.map((e) => ({ ...e, text: e.review })),
  };
};

const getAccountInfo = (state) => {
  const { accountInfo } = state.customer;
  return {
    id: accountInfo.id,
    address: accountInfo.address,
    firstName: accountInfo.firstName,
    createdDate: accountInfo.createdDate,
    averageRating: accountInfo.averageRating,
    reviewsCount: accountInfo.reviewsCount,
    about: accountInfo.about,
    photo: accountInfo.photo,
    seo: accountInfo.seo,
    licenceVerified: accountInfo.licenceVerified,
    phoneVerified: accountInfo.phoneVerified,
  };
};

const getIsLoading = (state) => state.customer.loading;

export { getAccountInfo, getFullInfo, getIsLoading, getReviews, getVehicles };
